import React from "react";
import { Music, Users, Zap } from "lucide-react";
import { bandData } from "../mock";

const About = () => {
  return (
    <section id="about" className="py-20 bg-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            About The Band
          </h2>
          <div className="w-24 h-1 bg-[#ff6b35] mx-auto" />
        </div>

        {/* Main Description */}
        <div className="mb-16">
          <p className="text-xl text-white/80 leading-relaxed text-center max-w-4xl mx-auto">
            {bandData.description}
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Power Trio */}
          <div className="bg-[#1a1a2e] rounded-lg p-8 hover:bg-[#222236] transition-all hover:transform hover:scale-105">
            <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mb-6 mx-auto">
              <Users size={32} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4 text-center">
              Power Trio
            </h3>
            <p className="text-white/70 text-center leading-relaxed">
              A tight-knit ensemble of bass, drums, and guitar creating a massive sound that defies our size.
            </p>
          </div>

          {/* Fusion Style */}
          <div className="bg-[#1a1a2e] rounded-lg p-8 hover:bg-[#222236] transition-all hover:transform hover:scale-105">
            <div className="w-16 h-16 bg-[#4a5aff] rounded-full flex items-center justify-center mb-6 mx-auto">
              <Music size={32} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4 text-center">
              Fusion Masters
            </h3>
            <p className="text-white/70 text-center leading-relaxed">
              Blending progressive rock, jazz, Latin, and world music into a unique sonic experience.
            </p>
          </div>

          {/* Young Energy */}
          <div className="bg-[#1a1a2e] rounded-lg p-8 hover:bg-[#222236] transition-all hover:transform hover:scale-105">
            <div className="w-16 h-16 bg-[#00d9ff] rounded-full flex items-center justify-center mb-6 mx-auto">
              <Zap size={32} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4 text-center">
              Fresh Energy
            </h3>
            <p className="text-white/70 text-center leading-relaxed">
              Young, eager, and hungry to bring our explosive live show to venues everywhere.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
